module.exports = __webpack_public_path__ + "img/view-grid.624c7ab6.svg";